var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"pagination mt-4 justify-content-center"},_vm._l((_vm.totalPages),function(pageNumber){return _c('li',{key:pageNumber,staticClass:"page-item mx-1"},[_c('a',{staticClass:"page-link",class:{
          'bg-primary': pageNumber === _vm.currentPage,
          'bg-primary-light': pageNumber !== _vm.currentPage,
        },style:({
          color: _vm.textColor(pageNumber),
        }),attrs:{"href":"#"},on:{"click":function($event){return _vm.$emit('fetch-list', pageNumber)}}},[_vm._v(_vm._s(pageNumber))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }